<template>
    <div>
        <dd class="c_connect_comm selectRoom fix c_first_selectRoom" >
            <i class="check_box c_check_box stateroom_check" 
            :class="{ cur: isSelected}" @click="onConnectRoomSelected(connectId, firstStateroom.cruiseId)"></i>
            <div class="f-fl img_box">
                <img :src="getStateroomImage(firstStateroom)">
            </div>
            <div class="f-fl tool_box">
                <a class="tool_btn delete_btn" @click="onDeleteConnectRoom(connectId)">
                    <i class="detail_ico_18 delete_ico"></i>删除2间
                </a>
            </div>
            <div class="f-fl info_box">
                <div class="info_title">
                    <span class="cabinName">{{getStateroomName(firstStateroom)}}</span>
                    <div clss="connect-wrap">
                        <NrpTag 
                            :isNrp="firstStateroom.isnrp"
                            :isFortyEightHoursNrpCruise="firstStateroom.isFortyEightHoursNrpCruise"
                            :direction="'left'"
                            :targetContainer="'app'"
                            :customClasses="['shoppingCartStateroomNrp']"
                        />
                        <img class="c_connect_pics" @click="showConnectRoomPopup"
                            src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_inf.png" alt="">
                    </div>
                </div>
                <div class="info_tags">舱房: {{getStateroom(firstStateroom).areaInfo}}&nbsp;&nbsp;|&nbsp;&nbsp;{{getStateroomBalcony(firstStateroom)}}</div>
                <div class="info_price ">{{firstStateroom.isnrp ? '早订特惠价': '优惠价'}}(含税): <span><em>￥</em>
                    <span class="stateroomPrice">{{firstStateroom.netAmount > 0 ? firstStateroom.netAmount.toFixed(0): ''}}</span></span>/人起
                </div>
                <!-- <div class="info_price original_price">零售指导价(含税): ￥5446/人起</div>
                <div class="soldOutText f-dn">售罄</div> -->
            </div>
        </dd>
        <dd class="selectRoom fix c_second_selectRoom c_connect_comm">
            <div class="f-fl img_box">
                <img src="https://resource.rcclchina.com.cn/000neo/Ship/SC/2V4V%E5%A4%B4%E5%9B%BE.JPG" alt=""></div>
            <div class="f-fl tool_box"></div>
            <div class="f-fl info_box">
                <div class="info_title"><span class="cabinName">{{getStateroomName(secondStateroom)}}</span>
                    <div clss="connect-wrap">
                        <NrpTag 
                            :isNrp="secondStateroom.isnrp"
                            :isFortyEightHoursNrpCruise="secondStateroom.isFortyEightHoursNrpCruise"
                            :direction="'left'"
                            :targetContainer="'app'"
                            :customClasses="['shoppingCartStateroomNrp']"
                        />
                        <img class="c_connect_pics" @click="showConnectRoomPopup"
                            src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_inf.png" alt="">
                    </div>
                </div>
                <div class="info_tags">舱房: {{getStateroom(secondStateroom).areaInfo}}&nbsp;&nbsp;|&nbsp;&nbsp;{{getStateroomBalcony(secondStateroom)}}</div>
                <div class="info_price ">{{secondStateroom.isnrp ? '早订特惠价': '优惠价'}}(含税): <span><em>￥</em>
                    <span class="stateroomPrice">{{secondStateroom.netAmount > 0 ? secondStateroom.netAmount.toFixed(0): ''}}</span></span>/人起
                </div>
                <!-- <div class="info_price original_price">零售指导价(含税): ￥5446/人起</div>
                <div class="soldOutText f-dn">售罄</div> -->
            </div>
        </dd>

    </div>
</template>

<script>
const NrpTag = () => import('@/components/Booking/NrpTag')
export default {
    name: "ShoppingCartConnectRoom",
    components: {
        NrpTag
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onConnectRoomSelected: {
            type: Function
        },
        onDeleteConnectRoom: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        }
    },
    methods: {
        getStateroom (shoppingCart) {
            if (!shoppingCart.stateroomPartRecord) {
                return {}
            }
            return shoppingCart.stateroomPartRecord
        },
        getStateroomName (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            if (!stateroom.stateroomCategoryCode) return ''
            let name = stateroom.cnName
            let code = stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return `${name}_${code}`
        },
        getStateroomBalcony (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            const balcony = stateroom.balconyAreaInfo
            if (!balcony || balcony == '' || balcony == '无') {
                return '无阳台'
            }
            return balcony
        },
        getStateroomImage (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            return stateroom.desImage
        }
    },
    computed: {
        firstStateroom () {
            if (this.shoppingCarts.length < 2) {
                return {}
            }
            return this.shoppingCarts[0]
        },
        secondStateroom () {
            if (this.shoppingCarts.length < 2) {
                return {}
            }
            return this.shoppingCarts[1]
        },
        isSelected () {
            return this.selectedShoppingCarts.length > 0
        },
        connectId () {
            return this.firstStateroom.connectId
        }
    }
}
</script>

<style lang="less" scoped>
dd {
    position: relative;
    margin-bottom: 16px;
    .check_box {
        position: absolute;
        top: 0;
        left: -25px;
        width: 18px;
        height: 18px;
        border: 1px solid #d3dadd;
        border-radius: 2px;
    }
    .check_box.c_check_box {
        left: 5px;
        top: 9px;
    }
    .check_box.cur {
        background: url(https://resource.rcclchina.com.cn/tui2/list/icon-checkBox-checked.png) no-repeat center;
        border-color: #006ab9;
    }
    .img_box {
        position: relative;
        width: 55%;
        margin-right: 5%;
        img {
            width: 100%;
        }
        .qiaohuStateroomBackground {
            border: 3px solid #ffe100;
        }
    }
    .tool_box {
        width: 40%;
        .delete_btn {
            margin-bottom: 30px;
            display: block;
            cursor: pointer;
            font-weight: 400;
            color: #747d80;
            .detail_ico_18.delete_ico {
                background: url(https://resource.rcclchina.com.cn/tui2/list/trash.png) no-repeat;
            }
        }
        .shoppingCartDeleteBtn {
            position: absolute;
            right: 22px;
            top: 64px;
             span {
                position: relative;
                width: 20px;
                height: 20px;
                border: 1px solid #d3dadd;
                background: #fff;
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
            }
            span.disabled {
                background-color: #F1F4F7;
            }
            span:before,span:after {
                content: '';
                display: block;
                position: absolute;
                background: #016bb9;
            }
            span:after {
                width: 10px;
                margin-left: -5px;
                top: 8px;
                height: 2px;
                left: 50%;
            }
            .disabled:before,.disabled:after {
                background: #a6aeb1;
            }
            .stateroomcount {
                display: inline-block;
                padding-left: 10px;
            }
            span.add {
                margin-left: 10px;
            }
            .add:before {
                height: 10px;
                margin-top: -9px;
                margin-left: -1px;
                width: 2px;
                left: 50%;
                top: 13px;
            }
        }
    }
    .info_box {
        .QIAOHU_CSS {
            width: 117px;
            height: 31px;
            margin-top: 5px;
        }
        .info_title {
            font-weight: bold;
            padding: 5px 0px;
        }
        .info_price {
            padding-top: 0px;
            span {
                font-size: 16px;
                color: #ff3022;
                em {
                    font-style: normal;
                    font-size: 12px;
                }
            }
        }
    }
}

dd.c_connect_comm {
    background-color: #FFF8CE;
    margin-left: -30px;
    margin-right: -14px;
    padding-left: 30px;
    .c_connect_pics {
        cursor: pointer;
        position: relative;
        top: -1px;
        margin-left: 5px;
    }
}

dd.c_first_selectRoom {
    padding-top: 10px;
    border-top: 3px solid #F8DE56;
    margin-bottom: 0px;
}

dd.c_second_selectRoom {
    padding-bottom: 10px;
    border-bottom: 3px solid #F8DE56;
    margin-bottom: 10px;
    padding-top: 10px;
}

</style>